import { render } from "./ChangePasswordComponent.vue?vue&type=template&id=44130b36"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__